import React, { useEffect, useState } from "react";

import { db } from "../../lib/firebaseCompat";

import CardSearchTable from "../shared/CardSearchTable";
import OrganizationTr from "./OrganizationTr";

import { useOrganization } from "../../hooks/useOrganization";
import { useAuth } from "../../hooks/usehooks.com/use-auth";

const orgTooltip = `Manage Organizations you belong to. Use the checkmark to switch between your organizations.`;

export default function OrganizationsTable() {
  const auth = useAuth();
  const organization = useOrganization();
  const [searchValue, setSearchValue] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [organizationNameSearch, setOrganizationNameSearch] = useState();

  const onSubmit = ({ searchOrgs }) => {
    setOrganizationNameSearch(searchOrgs);
  };

  useEffect(() => {
    if (!auth.user) {
      return;
    }

    const orgRef = db.collection("organizations");

    const orgNameWild = organizationNameSearch
      ? `${organizationNameSearch}~`
      : null;

    const query = [
      ["memberUids", "array-contains", auth.user.uid],
      ["name", ">=", organizationNameSearch],
      ["name", "<=", orgNameWild],
    ].reduce((accRef, args) => {
      const [field, op, arg] = args;
      if (arg) {
        return accRef.where(field, op, arg);
      } else {
        return accRef;
      }
    }, orgRef);

    const doQ = async () => {
      const snapshot = await query.orderBy("name").get();
      const orgs = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setOrganizations(orgs);
    };
    doQ();
  }, [auth.user, organizationNameSearch]);

  return (
    <CardSearchTable
      header="My Organizations"
      tooltip={orgTooltip}
      placeholder="Search by Organization Name"
      empty="No organizations are available for you to select. Please contact the CAVS Administrator."
      searchName="searchOrgs"
      onSubmit={onSubmit}
      columns={[
        "name",
        "", // edit
        "", // set as current
      ]}
    >
      {organizations.map((org) => {
        return <OrganizationTr key={org.id} org={org} />;
      })}
    </CardSearchTable>
  );
}
